
var yieldList1 = [];
var yieldList2 = [];
var mainCardNo;
var mainBrchna;
var dataRate;
var theFundty;
var walletPageno;
var timeType = 0;//超市类型
var beginTime = moment().subtract(1, 'months').format('YYYYMMDD');
var endTime = moment().format('YYYYMMDD');
var walletType; // 钱包交易类型
var qryTranKind;
var combinedSubAccountTransCodes = ['06001', '06010', '06020', '06030', '06143', '06144']; // 组合子账户交易类型
var targetProfitTransCodes = ['06040', '06050']; // 目标盈交易记录
var aPlusPayTransCodes = ['02604']; // A加付交易记录
var isContainIncome = '1';//是否展示钱包收益
var isClickTransactionType;//是否选择了交易类型
var isCustom = false;//是否是自定义日期从详情页回来

$(function () {
    var type = getParamsByName("type");
    console.log(getParamsByName(type))
    if (type == '2') {

        selectTag(type)
    }
    // toApi('qrywebankrelation.tml', function (data) {
    //     var cardList = data.cardlist;
    //     var orderState = data.oderState;
    //     var mainCardCashAcctId = data.mainCardCashAcctId;
    //     if (cardList && cardList.length > 0 && cardList[0].weiBankAcctNo) {
    //         if (cardList[0].card_state != '2') {
    //             $('#jy_18').show();
    //         }
    //     } else {
    //         // TODO 后端在用户信息查询接口新增字段
    //         var isOpenWbAcct = loadValue('isOpenWbAcct', false);
    //         if ((isNull(isOpenWbAcct) || isOpenWbAcct == 1) && mainCardCashAcctId) {
    //             $('#jy_18').show();
    //         }
    //     }
    // });

    var startd = addDate(currentDate(), -7);//起始时间
    var enddat = getNowDate();//截止时间
    var incodt = getNowDate();//收益时间

    if (isRealName()) {

        $("#stratTime").val();
        $("#endTime").val();
        //日历绑定ID
        $("#stratTime").jeDate({
            isinitVal: false,
            ishmsVal: false,
            minDate: '1970-07-01 00:00:00', //设定最小日期为当前日期
            maxDate: moment().format('YYYY-MM-DD'), //最大日期
            format: "YYYY-MM-DD",
            zIndex: 3000,
            choosefun: function (a, b, c) {
                var stratTime = $("#stratTime").val().slice(0, 4) + $("#stratTime").val().slice(5, 7) + $("#stratTime").val().slice(8, 10);
                var endDay = $("#endTime").val().slice(0, 4) + $("#endTime").val().slice(5, 7) + $("#endTime").val().slice(8, 10);
                if (endDay !== '' && Number(endDay) < Number(stratTime)) {
                    alertIknowMsg('结束日期不能小于开始日期');
                    $("#stratTime").val('');
                    return;
                }
                if (parseInt(endDay) - parseInt(stratTime) > 10000) {
                    alertIknowMsg('查询间隔不能超过1年');
                    $("#stratTime").val('');
                    return;
                }
                if (stratTime != '' && endDay != '') {
                    beginTime = stratTime;
                    endTime = endDay;
                    apiJyjl(theFundty, 1, walletType);//交易记录
                }
            }
        })
        //日历绑定ID
        $("#endTime").jeDate({
            isinitVal: false,
            ishmsVal: false,
            minDate: '1970-07-01 00:00:00', //设定最小日期为当前日期
            maxDate: moment().format('YYYY-MM-DD'), //最大日期
            format: "YYYY-MM-DD",
            zIndex: 3000,
            choosefun: function (a, b, c) {
                var stratTime = $("#stratTime").val().slice(0, 4) + $("#stratTime").val().slice(5, 7) + $("#stratTime").val().slice(8, 10);
                var endDay = $("#endTime").val().slice(0, 4) + $("#endTime").val().slice(5, 7) + $("#endTime").val().slice(8, 10);
                if (stratTime == '') {
                    alertIknowMsg('开始日期不能为空');
                    return;
                }
                if (Number(endDay) < Number(stratTime)) {
                    alertIknowMsg('结束日期不能小于开始日期');
                    $("#endTime").val('');
                    return;
                }
                if (parseInt(endDay) - parseInt(stratTime) > 10000) {
                    alertIknowMsg('查询间隔不能超过1年');
                    $("#endTime").val('');

                    return;
                }
                beginTime = stratTime;
                endTime = endDay;
                apiJyjl(theFundty, 1, walletType);//交易记录
            }
        })

        //根据绑卡列表获取安全卡，给红包交易时显示
        toApi('getbindbankcardlist.tml', function (data) {
            var mainFlag = 0;
            if (data.bindCardInfos.length > 0) {
                for (var i = 0; i < data.bindCardInfos.length; i++) {
                    if (data.bindCardInfos[i].mainFlag == 1) {
                        mainFlag = 1;
                        mainCardNo = data.bindCardInfos[i].cardno;
                        mainBrchna = data.bindCardInfos[i].brchna;
                        break;
                    }
                }
                if (mainFlag == 0) {
                    mainCardNo = data.bindCardInfos[0].cardno;
                    mainBrchna = data.bindCardInfos[0].brchna;
                }
            }
        });
    }

    toApi('qrywalletinfo.tml?startd=' + startd + '&enddat=' + enddat + '&incodt=' + incodt, function (data) {

        handleIndexRate(data.walout.yesrev, 'yesrev');
        handleIndexRate(data.walout.totalr, 'totalr');

        $('#walamt').html(toThousands(data.walout.walamt, 2) + '');
        $('#sevyie').html(format_nhsyl(data.walout.sevyie));

        smallFontSize(toThousands(data.walout.walamt, 2).toString(), 14, "walamt", "25px");
        smallFontSize(toThousands(data.walout.walamt, 2).toString(), 17, "walamt", "23px");

        var datel = [];
        var ratel = [];
        dataRate = data.walout.wyield;
        if (data.walout.wyield.length >= 7) {
            for (var t = data.walout.wyield.length - 7; t < data.walout.wyield.length; t++) {
                datel.push(data.walout.wyield[t].dateee.slice(4, 6) + "." + data.walout.wyield[t].dateee.slice(6, 8));
                ratel.push((data.walout.wyield[t].wekyie * 100).toFixed(4));
            }
            drawZxt(datel, ratel);
        }
    });

    apiSY(1);//钱包收益
    if (!isNull(localStorage.walletFundty)) {
        var fundty = localStorage.walletFundty;
        var pageno = localStorage.walletPageno;
        timeType = localStorage.walletTimeType;
        qryTranKind = localStorage.walletQryTranKind === 'undefined' ? '' : localStorage.walletQryTranKind;
        walletType = qryTranKind
        theFundty = fundty

        isContainIncome = localStorage.isContainIncome === 'undefined' ? '1' : localStorage.isContainIncome;
        localStorage.walletFundty = "";
        localStorage.walletPageno = "";
        localStorage.walletTimeType = "";
        localStorage.isContainIncome = "";

        if (timeType == '5') {
            isCustom = true;
            beginTime = localStorage.startTime;
            endTime = localStorage.endTime;
            localStorage.startTime = '';
            localStorage.endTime = '';
        }
        setTime(timeType);

    } else {
        apiJyjl(0, 1, 'ALL');//交易记录
    }
    apiRateSeven(1);//7日年化收益率
});

function QBYesHandle() {
    if ($("#isContainIncome").is(":checked")) {
        isContainIncome = '0';
        apiJyjl(isClickTransactionType, 1, walletType);//这里的入参第一个不能传查询类型，应该会覆盖掉原来的样式
    } else {
        isContainIncome = '1';
        apiJyjl(isClickTransactionType, 1, walletType);//这里的入参第一个不能传查询类型，应该会覆盖掉原来的样式
    }
}
function apiRateSeven(pageno) {
    toApi('qrywalletproinfo.tml?startd=' + addDate(currentDate(), -30) + "&enddat=" + getNowDate() + "&pageno=" + pageno + "&pagesz=" + 10, function (data) {

        if (data.counts > 0) {
            $('#date_now').html(fdate(data.wyield[0].dateee));
            data.wyield.forEach(function (e) {
                e.syl = (e.wekyie * 100).toFixed(4) + '%';//7日年化
                e.wekyie = (e.milrev).toFixed(4);
                // var rateAndColor = handleFundRate(e.wekyie);//万份收益
                // e.wekyie = rateAndColor.rate;
                e.wekyieColor = 'cello';
                if (isNull(e.dateee)) {
                    e.dateee = '-';
                } else {
                    e.dateee = fdate(e.dateee);
                }

            });

            var htmlList = template('tpl_sy', { "list": data.wyield });
            $('#syl').html(htmlList);

            var htmlPage = template('tpl_page', { "fun": "toPage3", "index": pageno, "pages": Math.ceil(data.counts / 10) });
            $('#rateSeven_page').html(htmlPage);
        } else {
            $('#syl').html('<div class="no-bind"><p>抱歉！没有找到您要的信息</p></div>');
        }
    }, 'wallet', '');
}
function apiSY(pageno) {
    if (!isRealName()) {
        $('#havadata1').hide();
        $('#nodata1').show();
        return;
    }
    toApi('qrywallteincome.tml?trantp=3&pagesz=10&pageno=' + pageno, function (data) {

        if (data.wlinfo.length > 0) {
            $('#nodata1').hide();
            $('#havadata1').show();
            data.wlinfo.forEach(function (e) {
                if (e.trandt2 == undefined) {
                    e.trandt2 = '';
                } else {
                    e.trandt2 = fdate(e.trandt2);
                }

                var tempTranam = numberFormatter(e.tranam, 2);
                e.tranam = tempTranam.value;
                e.tranamColor = tempTranam.color;

                e.fundIncome = toThousands(e.fundIncome, 4);
                e.yield = format_nhsyl(e.yield);
            });

            var htmlList = template('tpl_qsy', { "list": data.wlinfo });
            $('#list_box').html(htmlList);

            var htmlPage = template('tpl_page', { "fun": "toPage2", "index": pageno, "pages": Math.ceil(data.counts / 10) });
            $('#sy_page').html(htmlPage);
        } else {
            $('#havadata1').hide();
            $('#nodata1').show();
        }
    }, 'wallet', '');
}

function apiJyjl(fundty, pageno, wType, index) {
    theFundty = fundty;
    walletPageno = pageno;
    walletType = wType;
    [0, 3, 4, 14, 17, 18, 19, 20].forEach(function (i) {
        if (fundty == i) {
            sessionStorage.setItem('isClickTransactionType', fundty);
            $('#jy_' + i).addClass('active');
        } else {
            $('#jy_' + i).removeClass('active');
        }
    });
    isClickTransactionType = sessionStorage.getItem('isClickTransactionType');
    if (!isNull(index) && !isCustom) {// 选择了自定义日期还没有选择日期但是不是从详情页返回
        return;
    }


    if (!isRealName()) {
        $('#jyjl').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无钱包交易记录</p></div></td>');
        $('#jyjl_page').html('');
        return;
    }
    sessionStorage.setItem('isContainIncome', isContainIncome);
    if (isContainIncome == '0') {
        $('#isContainIncome').attr('checked', true)
    }
    var params = {
        "pageNo": walletPageno,
        "pageSize": 10,
        "flowWay": walletType,
        "transAcctId": '',
        "startDate": beginTime,
        "endDate": endTime,
        "isContainIncome": isContainIncome

    };
    toApi_toAcCg('S15Q134', params, function (data) {
        if (data.walletFlowInfoList == null || data.walletFlowInfoList.length <= 0) {
            $('#jyjl').html('<td colspan="7"><div class="hold-box h-min"><p class="no-data">' + '暂无钱包交易记录' + '</p></div></td>');
        } else {
            data.walletFlowInfoList.forEach(function (e) {

                e.trandt = e.payReceiveTime.slice(0, 4) + '-' + e.payReceiveTime.slice(4, 6) + '-' + e.payReceiveTime.slice(6, 8) + ' ' + e.payReceiveTime.slice(8, 10) + ':' + e.payReceiveTime.slice(10, 12) + ':' + e.payReceiveTime.slice(12, 14);
                if (!isNull(e.transAfterShare)) {
                    e.transAfterShare = e.transAfterShare
                } else {
                    e.transAfterShare = '';
                }

            });
            var htmlList = template('tpl_jl1', {
                "list": data.walletFlowInfoList
            });
            $('#jyjl').html(htmlList);
            var htmlPage = template('tpl_page', {
                "fun": "toPage",
                "index": pageno,
                "pages": Math.ceil(data.counts / 10),
                "type": fundty
            });
            $('#jyjl_page').html(htmlPage);
        }
    });
}

function setTime(index) {
    for (var i = 0; i < 6; i++) {
        $('#box-id' + i).removeClass('active');
    }
    $('#box-id' + index).addClass('active');
    timeType = index;
    if (index == 0) {
        beginTime = moment().subtract(1, 'months').format('YYYYMMDD');
        endTime = moment().format('YYYYMMDD');
        $('#timeBox_QB').addClass('none');
        $("#stratTime").val();
        $("#endTime").val();
        isCustom = false;
    } else if (index == 1) {
        beginTime = moment().subtract(3, 'months').format('YYYYMMDD');
        endTime = moment().format('YYYYMMDD');
        $('#timeBox_QB').addClass('none');
        $("#stratTime").val('');
        $("#endTime").val('');
        isCustom = false;
    } else if (index == 2) {
        beginTime = moment().subtract(6, 'months').format('YYYYMMDD');
        endTime = moment().format('YYYYMMDD');
        $('#timeBox_QB').addClass('none');
        $("#stratTime").val('');
        $("#endTime").val('');
        isCustom = false;
    } else if (index == 3) {
        beginTime = moment().subtract(1, 'years').format('YYYYMMDD');
        endTime = moment().format('YYYYMMDD');
        $('#timeBox_QB').addClass('none');
        $("#stratTime").val('');
        $("#endTime").val('');
        isCustom = false;
    } else if (index == 4) {
        beginTime = new Date().getFullYear() + '0101';
        endTime = moment().format('YYYYMMDD');
        $('#timeBox_QB').addClass('none');
        $("#stratTime").val('');
        $("#endTime").val('');
        isCustom = false;
    } else if (index == 5) {
        $('#timeBox_QB').removeClass('none');
        apiJyjl(theFundty, 1, walletType, index);
        return;
    }

    apiJyjl(theFundty, 1, walletType);

}
function selectTag(index) {
    timeType = index;
    for (var i = 1; i <= 3; i++) {
        if (i == index) {
            $('#d' + i).show();
            $('#h' + i).addClass('active');
        } else {
            $('#d' + i).hide();
            $('#h' + i).removeClass('active');
        }
    }
}
function toPage3(index, pages, type) {
    if (type == 1) {
        if (index + 1 <= pages) {
            apiRateSeven(index + 1);
        }
    } else if (type == -1) {
        if (index - 1 >= 1) {
            apiRateSeven(index - 1);
        }
    } else {
        var num = 1;
        try {
            num = parseInt($('#toPage3').html());
        } catch (err) {
            num = 1;
        }
        if (num > 0 && num <= pages) {
            apiRateSeven(num);
        }
    }
}
function toPage2(index, pages, type) {

    if (type == 1) {
        if (index + 1 <= pages) {
            apiSY(index + 1);
        }
    } else if (type == -1) {
        if (index - 1 >= 1) {
            apiSY(index - 1);
        }
    } else {
        var num = 1;
        try {
            num = parseInt($('#toPage2').html());
        } catch (err) {
            num = 1;
        }
        if (num > 0 && num <= pages) {
            apiSY(num);
        }
    }
}

function toPage(index, pages, type) {
    [0, 3, 4, 5, 12].forEach(function (e) {
        if ($('#jy_' + e).hasClass('active')) {
            theFundty = e;
        }
    });


    if (type == 1) {
        if (index + 1 <= pages) {
            apiJyjl(theFundty, index + 1, '', qryTranKind);
        }
    } else if (type == -1) {
        if (index - 1 >= 1) {
            apiJyjl(theFundty, index - 1, '', qryTranKind);
        }
    } else {
        var num = 1;
        try {
            num = parseInt($('#toPage').html());
        } catch (err) {
            num = 1;
        }
        if (num > 0 && num <= pages) {
            apiJyjl(theFundty, num, '', qryTranKind);
        }
    }
}

function changeYieldType(type) {
    if (type === 1) {
        $('#nearWeek').addClass('active');
        $('#nearMonth').removeClass('active');
        if (yieldList1.length > 0) {
            var htmlList = template('tpl_sy', { "list": yieldList1 });
            $('#syl').html(htmlList);
        } else {

        }
    } else {
        $('#nearWeek').removeClass('active');
        $('#nearMonth').addClass('active');
        if (yieldList2.length > 0) {
            var htmlList = template('tpl_sy', { "list": yieldList2 });
            $('#syl').html(htmlList);
        } else {

        }
    }
}

function isString(num) {
    return Object.prototype.toString.apply(num) == '[object String]';
}

function handleIndexRate(indexRate, mark) {
    var rateAndColor = {};
    if (!isNull(indexRate)) {
        indexRate = Number(indexRate);
        if (indexRate > 0) {
            indexRate = '+' + indexRate;
            rateAndColor = 'red';
        } else if (indexRate < 0) {
            rateAndColor = 'green';
        } else {
            rateAndColor = 'cello';
        }
        indexRate = toThousands(indexRate, 2);
    } else {
        indexRate = '-';
        rateAndColor = 'cello';
    }

    $('#' + mark).html(indexRate);
    $('#' + mark).addClass(rateAndColor);
}

function handleFundRate(fundRate) {
    var rateAndColor = {};
    if (!isNull(fundRate)) {
        fundRate = (fundRate).toFixed(4);
        if (fundRate > 0) {
            fundRate = '+' + fundRate;
            rateAndColor.color = 'red';
        } else if (fundRate < 0) {
            rateAndColor.color = 'green';
        } else {
            rateAndColor.color = 'cello';
        }
    } else {
        fundRate = '-';
        rateAndColor.color = 'cello';
    }
    rateAndColor.rate = fundRate;
    return rateAndColor;
}

function drawZxt(dateList, rateList) {

    var tpoint = [];
    var pointt = {};
    pointt.name = "";
    pointt.value = rateList[rateList.length - 1] + "%";
    pointt.xAxis = dateList[dateList.length - 1];
    pointt.yAxis = rateList[rateList.length - 1];
    pointt.symbol = "../images/temp/po.png";
    tpoint.push(pointt);

    var ymm = getMinMax(rateList, []);
    var tempstep = (ymm[3] * 0.4).toFixed(4);
    pointt.yAxis = parseFloat(pointt.yAxis) + parseFloat(tempstep);

    var theCharts = echarts.init(document.getElementById('wlzxt'));
    option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                // type: 'none',
                type: 'line',
                lineStyle: {
                    color: '#61c0ed',
                    width: 1,
                    type: 'solid'
                },
            },
            formatter: function (params) {
                return params[0].name + "<br/>" + params[0].value + "%";
            }
        },
        calculable: false,
        grid: {       //直角坐标系内绘图网格
            x: '50px',
            y: '30px',
            x2: '30px',
            containLabel: true,
            borderWidth: '0px',
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: false,
                axisLine: { lineStyle: { color: '#c2b9ba', width: 1, type: 'solid' } },
                splitLine: { show: false, },
                data: dateList
            }
        ],
        yAxis: [
            {
                type: 'value',
                splitLine: { show: false, },
                axisLine: { lineStyle: { color: '#c2b9ba', width: 1, type: 'solid' } },
                axisLabel: {
                    formatter: function (value, index) {
                        return value.toFixed(4);
                    }
                },
                min: ymm[0], max: ymm[1],
            }
        ],
        series: [
            {
                name: '七日年化收益率',
                type: 'line',
                stack: '',
                // itemStyle: {normal: {areaStyle: {type: 'default'}}},
                itemStyle: {
                    normal: {
                        borderWidth: 1,
                        // color:'#f6806c',
                        lineStyle: { color: '#f6806c' },
                        areaStyle: { type: 'default', color: '#f8e6e4' }
                    }
                },
                data: rateList,
                markPoint: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none'
                        }
                    },
                    symbol: 'pin',
                    symbolSize: [28, 12],
                    fontSize: '24',
                    itemStyle: {
                        normal: {
                            color: '#fd6564',
                            label: {
                                formatter: function (p, n, v) {    //n name   v->value
                                    return p.value;
                                },
                            }
                        }
                    },
                    data: tpoint
                }
            }
        ]
    };
    theCharts.setOption(option);
}
var oldDataNum;
function regetList(dateNum) {
    if (dateNum == oldDataNum) {
        return;
    }
    oldDataNum = dateNum;
    var datel = [];
    var ratel = [];
    if (dataRate.length >= dateNum) {
        for (var t = dataRate.length - dateNum; t < dataRate.length; t++) {
            datel.push(dataRate[t].dateee.slice(4, 6) + "." + dataRate[t].dateee.slice(6, 8));
            ratel.push((dataRate[t].wekyie * 100).toFixed(4));
        }
        drawZxt(datel, ratel);
    }
}

function detail(prcscd, orderNo, requestNo, fundCode, pkId, agencyNo) {
    // if(prcscd == '02202' || prcscd == '02401' || prcscd == '02402'){
    // if (isNull(dividendFund)) {
    //     return;
    // }

    // if (prcscd == '02202' && capitalMode == 'K' && remark == 'HK' && transt == '3') {
    //     alertIknowMsg('您已汇款。<br/>如有疑问，请详询鹏华客服热线400-6788-533');
    //     return;
    // }

    // if (aPlusPayTransCodes.includes(prcscd)) {
    //     var alertmsg = ('WQ' === capitalMode) ? 'A加付消费记录暂时无法查看详情' : '转托管记录暂时无法查看详情';
    //     alertIknowMsg(alertmsg);
    //     return;
    // }

    // if (combinedSubAccountTransCodes.indexOf(prcscd) > -1) {
    //     combinedTip('该交易记录暂时无法查看详情,请前往鹏华A加钱包查看');
    //     return;
    // }

    // if (targetProfitTransCodes.indexOf(prcscd) > -1) {
    //     combinedTip('目标盈交易记录暂时无法查看详情,请前往鹏华A加钱包查看');
    //     return;
    // }

    // if (dividendFund == '3' || dividendFund == '4') {
    //     combinedTip('组合交易记录暂时无法查看详情,请前往鹏华A加钱包查看');
    //     return;
    // }

    if (prcscd == "0" && orderNo == "0") { return }
    else {
        localStorage.walletFundty = theFundty;
        localStorage.walletPageno = walletPageno;
        localStorage.walletTimeType = timeType;
        localStorage.walletQryTranKind = walletType;
        localStorage.isContainIncome = sessionStorage.getItem("isContainIncome");
        localStorage.startTime = beginTime;
        localStorage.endTime = endTime;
        // sessionStorage.setItem("pageIdToTransActionDetails", "2");
        window.location.href = phURL + "account/detail.html?orderNo=" + orderNo + "&transCode=" + prcscd + "&requestNo=" + requestNo + "&fundCode=" + fundCode + "&pkId=" + pkId + "&agencyNo=" + agencyNo + "&URL=wallet/wallet.html";

    }
    //}else{
    //     window.location.href=phURL+"account/detail.html?orderNo="+orderNo+"&type=1&transCode="+prcscd_tmp;
    // }
}

function goDetail(pageId, fundCode, fundType, dividendFund, transCode) {
    if (isNull(fundCode)) {
        return;
    }

    if (combinedSubAccountTransCodes.indexOf(transCode) > -1) {
        combinedTip('组合产品暂不支持查看详情,请前往鹏华A加钱包查看');
        return;
    }

    if (targetProfitTransCodes.indexOf(transCode) > -1) {
        combinedTip('目标盈产品暂不支持查看详情,请前往鹏华A加钱包查看');
        return;
    }

    //组合详情
    if (dividendFund == '3' || dividendFund == '4') {
        combinedTip('组合产品暂不支持查看详情,请前往鹏华A加钱包查看');
        return;
    } else {
        window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&fundType=' + fundType;
    }
}
